import { FC } from 'react';
import { Box, BoxProps, Icon as RooIcon, IconProps as RooIconProps } from '@qga/roo-ui/components';
import { themeGet } from '@styled-system/theme-get';
import styled from '@emotion/styled';

const IconBackground = styled(Box)`
  border-radius: ${themeGet('radii.rounded')};
  line-height: 1;
`;

type IconPropKeys = 'name' | 'size' | 'title' | 'color';

export type IconProps = Pick<RooIconProps, IconPropKeys> & Omit<BoxProps, IconPropKeys>;

const Icon: FC<IconProps> = ({ name, size, title, color, ...boxProps }) => (
  <IconBackground display="inline-block" {...boxProps}>
    <RooIcon name={name} size={size} title={title} color={color} />
  </IconBackground>
);

export default Icon;
